<script setup lang="ts">
import HomeFeed from '../prompts/@components/HomeFeed.vue'
import { getBreadcrumbsJsonLd } from '~~/src/helpers/serp'
import { ElementalTypeEnum } from '~/types/elemental'

const jsonldBreadcrumbs = getBreadcrumbsJsonLd([
  { name: 'Visual Prompts', url: '/visual-prompts' },
])

useHead({
  script: [
    {
      hid: 'page-json-ld',
      type: 'application/ld+json',
      innerHTML: JSON.stringify(jsonldBreadcrumbs),
    },
  ],
})
</script>

<template>
  <NuxtLayout>
    <template #top-content />
    <template #outer-container>
      <HomeFeed :elemental-type-ids="[ElementalTypeEnum.Image]" />
    </template>
  </NuxtLayout>
</template>
